import { render, staticRenderFns } from "./QuotationBasicsTab.vue?vue&type=template&id=b5754cf6"
import script from "./QuotationBasicsTab.vue?vue&type=script&lang=js"
export * from "./QuotationBasicsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports